var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg034Nachos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 511.989 511.989",
    height: 512,
    viewBox: "0 0 511.989 511.989",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18.402 221.914 271.655 271.655c12.261 12.261 28.374 18.398 44.487 18.398 16.099 0 32.212-6.138 44.487-18.398 7.354-7.354 12.803-16.494 15.806-26.528l34.84-111.481c-22.043-8.882-37.677-30.403-37.677-55.592 0-69.375-27.012-134.59-76.069-183.647l-62.413-62.402-208.675 63.244c-9.946 2.974-19.087 8.423-26.44 15.776-24.537 24.536-24.537 64.439-.001 88.975zm283.598 18.054h30v30h-30zm0 120h30v30h-30zm-60-210h30v30h-30zm-30 120h30v30h-30zm-90-90h30v30h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m482 259.084c0-45.278 4.453-90.762 13.213-135.161 4.014-20.244 8.994-40.576 14.766-60.322 5.229-17.402.146-35.479-13.975-49.614-12.363-12.335-31.055-16.978-47.637-11.998l-158.144 46.201 46.919 46.919c54.726 54.727 84.858 127.471 84.858 204.859 0 16.538 13.462 30 30 30s30-13.462 30-30z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg034Nachos);
export default __webpack_public_path__ + "static/media/034-nachos.0eeb200eb103b8fc6074d02e08f22114.svg";
export { ForwardRef as ReactComponent };